import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';
import { IdleService } from '@services/idle/idle.service';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
    standalone: false
})
export class AuthenticationComponent implements OnInit, OnDestroy {

  public email: string;
  public password: string;

  public rememberCredentials = true;

  public isLoading: boolean;

  private returnUrl: string;

  private sessionSubscription;

  constructor(
    private ms: MessengerService,
    private route: ActivatedRoute,
    private router: Router,
    private idle: IdleService
  ) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.idle.clearTimeout();
    this.idle.removeListeners();
    this.sessionSubscription = this.ms.$activeSession.subscribe(session => {
      if (!session) {
        return;
      }
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
      const autologout = this.route.snapshot.queryParams['messagetype'] &&  this.route.snapshot.queryParams['messagetype'] === 'autologout';

      if (autologout) {
        this.isLoading = false;
        return;
      }

      if (session.level > 0) {
        setTimeout(() => {
          this.idle.addListeners();
          this.router.navigateByUrl(this.returnUrl);
        }, 0);
        return;
      }

      let outletRoute: string;

      for (const child of this.route.children) {
        if (child.outlet === 'authentication') {
          outletRoute = child.routeConfig.path;
        }
      }

      setTimeout(() => {
        this.router.navigate([{ outlets: { 'authentication': [outletRoute ? outletRoute : 'login'] } }], { relativeTo: this.route, queryParams: { returnUrl: this.returnUrl } });
      }, 0);
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    this.sessionSubscription.unsubscribe();
  }

}
